import React from 'react';
import styled from 'styled-components';
//
export const ThumbnailContainer = styled.div`
  line-height: 0;
  margin: 0 -0.5vw 2rem;
  padding-top: 0.5vw;
  width: 100%;
`;
